import { Link } from "react-router";
import React, { useState, useEffect, useMemo } from "react";
import { ProSidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import { Modal } from "react-bootstrap";
import LOGO from "../assets/images/logo.png";
import { Logout, tokens, GET, POST, getStorage, alert_url, format_date, calculate_water, replaceTextHTML, loadReplaceTextHTML } from "./CustomComponent.js";
import "../assets/css/bootstrap.css";
import "./global.js";
import "react-pro-sidebar/dist/css/styles.css";
import "@trendmicro/react-sidenav/dist/react-sidenav.css";

export default function NavbarComponent({ sidebar: initSidebar, page1, page2, page3 }) {
  const [sidebar, setSidebar] = useState(false);
  const [modalLogout, setModalLogout] = useState(false);
  const [modalSync, setModalSync] = useState(false);
  const [syncTime, setSyncTime] = useState(0);

  const path = window.location.pathname;
  const userType = getStorage("user_type"), projectId = getStorage("project_id");
  
  const roleMap = useMemo(() => (getStorage("role_detail") || []).reduce((m, r) => ({ ...m, [r.name]: r.role[0] === 1 }), {}), []);
  const hasR = (type) => !!roleMap[type];
  const isActive = (k) => {
    const target = k.startsWith("/") ? k : `/${k}`;
    return path === target || path.startsWith(`${target}/`);
  };

  useEffect(() => {
    (async () => {
      await loadReplaceTextHTML();
      await replaceTextHTML();
      // ตรวจสอบเวลาชำระเงิน
      if (["/record-water-usage", "/billing", "/record-receipt", "/record-other", "/record-bill"].some(isActive)) {
        const [resBill, resWater] = await Promise.all([
          GET(tokens, `v1/TH/bill-water-group/filter-search/${projectId}`, { data_search: "" }),
          GET(tokens, `v1/TH/water-manage/detail/${localStorage.getItem("water_id")}`, null)
        ]);
        const ct = resWater?.data?.data?.payment_close_time;
        if (ct && resBill?.data?.data?.length) {
          const [h, m] = ct.split(":");
          if (new Date().setHours(h, m, 0, 0) < Date.now()) alert_url("warning", "แจ้งเตือน", "สิ้นสุดเวลาการชำระเงินวันนี้แล้ว", "/bill-water");
        }
      }

      // Sync ข้อมูล
      const today = format_date(new Date());
      if (localStorage.getItem("sync_date") !== today) {
        setModalSync(true);
        const intv = setInterval(() => setSyncTime(p => Math.min(p + 0.2, 99)), 50);
        if (await calculate_water()) {
          await calculate_transaction_payment();
          localStorage.setItem("sync_date", today);
          clearInterval(intv);
          setSyncTime(100);
          setTimeout(() => setModalSync(false), 2000);
        } else {
          localStorage.clear();
          window.location.href = "/";
        }
      }
    })();
  }, [path, projectId]);

  const calculate_transaction_payment = async () => {
    try {
      await POST(tokens, "v1/TH/record-receipt/history/fix-transaction-payments/" + getStorage("project_id"), null);
    } catch (e) {
      console.error(e);
      return false;
    }
  };

  // ดักจับการเปลี่ยนแปลงใดๆ ก็ตามที่เกิดขึ้นบนหน้าจอ (DOM Mutation)
  useEffect(() => {
    let timeoutId;
    const observer = new MutationObserver(() => {
      clearTimeout(timeoutId);
      // ใช้ Debounce 100ms ป้องกันการเรียกใช้ฟังก์ชันรัวๆ ที่อาจทำให้ประสิทธิภาพตก
      timeoutId = setTimeout(async () => {
        observer.disconnect(); // ปิดการดักจับชั่วคราวขณะอัปเดตเพื่อกัน Infinite Loop
        await replaceTextHTML();
        observer.observe(document.body, { childList: true, subtree: true, characterData: true }); // เปิดดักจับใหม่
      }, 100);
    });

    observer.observe(document.body, { childList: true, subtree: true, characterData: true });

    return () => {
      clearTimeout(timeoutId);
      observer.disconnect(); // คืนค่า resource เมื่อ component unmount
    };
  }, []);


  // ตัวช่วยสร้าง MenuItem สั้นๆ ลดความซ้ำซ้อน
  const Item = ({ s, t, i, l, c = "", ex = false }) => s ? (
    <MenuItem className={c} icon={i && <label className="icon">{i}</label>} active={ex ? path === t : isActive(t)}>
      <Link to={t}>{l}</Link>
    </MenuItem>
  ) : null;

  return (
    <div>
      {/* Header Navbar */}
      <div className="w-100 mx-0 px-0 position-fixed d-flex justify-content-between bg-white shadow px-4 py-2" style={{ height: 60, zIndex: 1010 }}>
        <div className="align-items-center d-flex row mx-0">
          {initSidebar !== "false" && !isActive("pos") && <label className="d-block d-lg-none mr-3 mt-2" onClick={() => setSidebar(!sidebar)}><span className="icon-brand text-dark">{"\uf0c9"}</span></label>}
          <div className="position-relative wpx-200">
            <img className="hpx-32 mb-2 mx-auto" alt="logo" src={LOGO} /><br />
            <small className="position-absolute" style={{ left: 100, bottom: 4 }}>{process.env.REACT_APP_VERSION}</small>
            <small className="position-absolute text-8" style={{ right: 0, bottom: -6 }}>©copy right by c.d.s. service .co.,ltd and OMS service</small>
          </div>
          <div className="d-none d-md-flex">
            <div className="border-right mx-3" style={{ height: 24 }}></div>
            <small className="text-secondary">{page1}</small>
            {page2 && <small className={page3 ? "text-secondary ml-2" : "text-primary ml-2"}> &gt; {page2}</small>}
            {page3 && <small className="text-primary ml-2"> &gt; {page3}</small>}
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-center">
          <div>
            <b className="ml-auto mr-3 d-none d-sm-flex">{getStorage("full_name")}</b>
            <small className="mr-3 align-items-center d-none d-sm-flex pointer" onClick={() => {
              localStorage.removeItem("replace_text");
              
              window.location.href = "/choose-project"}}>{getStorage("project_name")}</small>
          </div>
          <span className="pointer btn-white icon text-danger text-14" onClick={() => setModalLogout(true)}>{"\uf2f5"}</span>
        </div>
      </div>

      {/* Sidebar Menu */}
      <ProSidebar className="full-screen" breakPoint="lg" toggled={sidebar}>
        <Menu>
          <Item s={hasR("customer")} t="/customer" i={"\uf007"} l="ข้อมูลลูกค้าโครงการ 🟢" />
          <Item s={hasR("record-water-usage")} t="/temp-record-water-usage" i={"\uf043"} l="ข้อมูลค่าใช้จ่ายโครงการ 🟢" />

          {(hasR("billing") || hasR("record-receipt") || hasR("receipt-adjustment") || hasR("record-other") || hasR("bill-water") || hasR("remittance") || hasR("usage-history") || hasR("capital-payment-info") || userType === "owner") && (
            <SubMenu icon={<label className="icon">{"\uf543"}</label>} title="ข้อมูลจัดเก็บค่าใช้จ่าย" defaultOpen={["billing", "record-receipt", "receipt-adjustment", "record-other", "record-bill", "bill-water", "remittance", "usage-history", "capital-payment-info", "water-payment-info", "cut-of"].some(isActive)}>
              <Item s={hasR("billing")} t="/billing" l="ออกใบแจ้งหนี้ 🟢" />
              <Item s={hasR("record-receipt")} t="/record-receipt" l="รับชำระค่าใช้จ่าย 🟢" />
              <Item s={hasR("receipt-adjustment")} t="/receipt-adjustment" l="ปรับปรุงใบเสร็จรับเงิน 🟢" />
              <Item s={hasR("record-other")} t="/record-other" l="บันทึกรายรับอื่นๆ 🟢" />
              <Item s={hasR("record-other")} t="/record-bill" l="ออกใบแจ้งหนี้อื่นๆ 🟢" />
              <Item s={hasR("bill-water")} t="/bill-water" l="การจัดเก็บค่าใช้จ่าย 🟢" />
              <Item s={hasR("remittance")} t="/remittance" l="การนำส่งเงินค่าใช้จ่าย 🟢" />
              <Item s={hasR("usage-history")} t="/usage-history" l="ประวัติค่าใช้จ่าย 🟢" />
              <Item s={hasR("capital-payment-info")} t="/capital-payment-info" l="ข้อมูลการรับชำระเงินทุน 🟢" />
              <Item s={hasR("water-payment-info")} t="/water-payment-info" l="ข้อมูลจัดเก็บค่าใช้จ่าย 🟢" />
              <Item s={hasR("cut-of")} t="/cut-of" l="รายการตัดหนี้ 🟢" />
            </SubMenu>
          )}

          <Item s={hasR("all-report")} t="/all-report" i={"\uf07b"} l="รายงานสรุปผล" />
          <Item s={hasR("import") || userType === "owner"} t="/import" i={"\uf07b"} l="นำเข้าไฟล์ข้อมูล 🟢" />

          {(hasR("employee") || hasR("role")) && (
            <SubMenu icon={<label className="icon">{"\uf007"}</label>} title="ข้อมูลผู้ใช้ 🟢" defaultOpen={isActive("employee") || isActive("role")}>
              <Item s={hasR("employee")} t="/employee" l="รายชื่อผู้ใช้ทั้งหมด 🟢" />
              <Item s={hasR("role")} t="/role" l="บทบาทผู้ใช้ 🟢" />
            </SubMenu>
          )}

          {(hasR("pay-list") || hasR("manage-water") || hasR("letter") || userType === "owner") && (
            <SubMenu icon={<label className="icon">{"\uf013"}</label>} title="ตั้งค่า 🟢" defaultOpen={["profile-code", "profile", "manage-water", "receipt", "receipt-other", "invoice-by-room", "letter", "invoice-other"].some(isActive)}>
              <Item s={hasR("pay-list")} t="/profile-code" l="รายการรับชำระ 🟢" />
              <Item s={hasR("manage-water")} t="/manage-water" l="จัดการอัตราค่าน้ำ 🟢" />
              <Item s={userType === "owner"} t="/profile" l="จัดการโปรไฟล์ 🟢" />
              <Item s={hasR("letter")} t="/receipt" l="(เอกสาร) ใบเสร็จรับเงิน 🟢" ex={true} />
              <Item s={hasR("letter")} t="/receipt-other" l="(เอกสาร) รายรับอื่น ๆ 🟢" />
              <Item s={hasR("letter")} t="/invoice-by-room" l="(เอกสาร) ใบแจ้งหนี้ตามห้อง 🟢" />
              <Item s={hasR("letter")} t="/letter" l="(เอกสาร) จดหมายแจ้งเตือน 🟢" />
              <Item s={hasR("letter")} t="/invoice-other" l="(เอกสาร) ใบแจ้งหนี้อื่น ๆ 🟢" />
            </SubMenu>
          )}

          <Item s={userType === "owner"} t="/logfile" i={"\uf017"} l="ล็อกไฟล์ 🟢" />
          <Item s={hasR("bookbank")} t="/bookbank" i={"\uf02d"} l="บันทึก Bookbank" />
          <Item s={hasR("statement")} t="/statement" i={"\uf02d"} l="บันทึก statement (บัญชี)" />
        </Menu>
      </ProSidebar>

      {/* Logout Modal */}
      <Modal show={modalLogout} onHide={() => setModalLogout(false)}>
        <Modal.Header><Modal.Title><b>ออกจากระบบ</b></Modal.Title></Modal.Header>
        <Modal.Body>
          <div className="w-100 mb-3"><label>ยืนยันการออกจากระบบหรือไม่</label></div>
          <div className="w-100 d-flex">
            <div className="w-50 p-1"><button className="btn btn-outline-primary w-100" onClick={() => setModalLogout(false)}>ยกเลิก</button></div>
            <div className="w-50 p-1"><button className="btn btn-primary w-100" onClick={Logout}>ออกจากระบบ</button></div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Sync Modal */}
      <Modal show={modalSync} dialogClassName="modal-fullscreen">
        <Modal.Body>
          <div className="w-100 min-vh-100 d-flex justify-content-center align-items-center">
            <div className="text-center">
              <h2 className="text-bold mb-3">กำลัง sync ข้อมูลระบบ</h2>
              <div className="hpx-24 wpx-320 border bg-light position-relative">
                <div style={{ width: (syncTime / 100) * 320 }} className="bg-primary hpx-24"></div>
                <label>{syncTime.toFixed(2)} %</label>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}